module.exports = __webpack_public_path__ + "static/onething-ab3e5537a2ae5a25e8c12c5ab8ab9dd7.png";